import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { GROUP_APPROVED } from '_utils/constant'
import { getUserInfo, getUserToken, setRedirectAfterLogin } from '_utils/localData'

const joinPath = (group) => `/group/join/${group.id}`
const detailPath = (group) => `/group/list-events?groupId=${group.id}`

const toGroupInfo = (group) => ({
  host: group.name,
  hostname: group.hostName || '',
  approval: group.groupQuestion ? 'question' : (group.autoApproval ? 'open' : 'approval'),
  question: group.groupQuestion || group.question || '',
  groupId: group.id,
})

// Join control of a group on the landing map:
// members visit the group, logged-in users open the join page,
// logged-out visitors sign in (or sign up from there) first, then land on the join page
const useLandingGroupAction = () => {
  const history = useHistory()

  // Groups the logged-in user is already an approved member of (pending requests still show Join)
  const memberGroupIds = useMemo(() => {
    if (!getUserToken()) return new Set()
    const myGroups = getUserInfo()?.groups || []
    return new Set(myGroups.filter((g) => g.approval === GROUP_APPROVED).map((g) => g.gid))
  }, [])

  return (group) => {
    if (memberGroupIds.has(group.id)) {
      return { label: 'Visit Group', onClick: () => history.push(detailPath(group)) }
    }
    return {
      label: group.autoApproval ? 'Join' : 'Request to Join',
      onClick: () => {
        if (getUserToken()) {
          history.push(joinPath(group))
          return
        }
        setRedirectAfterLogin(joinPath(group))
        history.push('/sign-in', { groupInfo: toGroupInfo(group) })
      },
    }
  }
}

export default useLandingGroupAction
